export type SubTabId = 'marketing' | 'suporte' | 'projeto' | 'criacao'

export type TaskExecutor = 'Equipe' | 'Gerencia'

export interface TaskEffort {
  id: string
  task: string
  hours: string
  executor: TaskExecutor
}

export const ESFORCO_SUB_TABS: { id: SubTabId; label: string }[] = [
  { id: 'marketing', label: 'Marketing' },
  { id: 'suporte', label: 'Suporte' },
  { id: 'projeto', label: 'Projeto' },
  { id: 'criacao', label: 'Criação' },
]
